import { RootState } from '../../store';
import { CommonState } from './contracts/state';

export const selectCommon = (state: RootState): CommonState => state.common;